import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AppNoInfo } from "@/layout/AppComponents";
import BreadcrumbHandler from "@/layout/components/breadcrumb/BreadcrumbHandler";
import errorHandler from "@/layout/components/error/ErrorHandler";
import GlobalImportResultView from "@/layout/screenSpecifics/Modules/GlobalLegalCompliance/Import/GlobalImportResultView";
import { axiosPath, path } from "@/routing/helpers/router";

export default function GlobalLegalComplianceImportScreen() {
  const { moduleBridgeHex, importMilestoneId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const goToEvaluation = useCallback(
    () =>
      navigate(
        path({
          name: "user_module_globalLegalCompliance_evaluation",
          params: {
            moduleBridgeHex,
            page: 1,
            filtersHex: 0,
          },
        }),
      ),
    [moduleBridgeHex, navigate],
  );

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios
      .post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_import_getImportMilestone",
        ),
        {
          moduleBridgeHex,
          importMilestoneId,
        },
      )
      .then(({ data }) => {
        if (!cancelled) {
          setResult(data);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setLoading(false);
          dispatch(errorHandler(e));
          goToEvaluation();
        }
      });

    return () => {
      cancelled = true;
    };
  }, [moduleBridgeHex, importMilestoneId, dispatch, goToEvaluation]);

  return (
    <>
      <BreadcrumbHandler paths={[{ name: "Resultado de la importación" }]} />
      <main role="main" className="col-md-12 col-lg-12 px-md-4">
        {loading || !result ? (
          <AppNoInfo minHeight={window.innerHeight - 60} />
        ) : (
          <GlobalImportResultView result={result} onBack={goToEvaluation} />
        )}
      </main>
    </>
  );
}
